import { Api } from '../services/api.ts';
import type { AtlasEncuadre, AtlasObjetivoEspecifico } from '../types/index.ts';

let encuadreData: AtlasEncuadre | null = null;
let objetivosData: AtlasObjetivoEspecifico[] = [];

export function initDashboard() {
  const titleEl = document.getElementById('dash-thesis-title');
  const subtitleEl = document.getElementById('dash-thesis-subtitle');
  const problemEl = document.getElementById('dash-problem');
  const hypothesisEl = document.getElementById('dash-hypothesis');
  const generalObjEl = document.getElementById('dash-general-obj');
  const oeContainer = document.getElementById('dash-oe-container');

  // Modales
  const modalEncuadre = document.getElementById('modal-edit-encuadre');
  const modalOE = document.getElementById('modal-edit-oe');
  const formEncuadre = document.getElementById('form-edit-encuadre') as HTMLFormElement | null;
  const formOE = document.getElementById('form-edit-oe') as HTMLFormElement | null;

  const btnEditEncuadre = document.getElementById('btn-edit-encuadre');
  const btnAddOE = document.getElementById('btn-add-oe');
  const btnCloseModalEncuadre = document.getElementById('btn-close-modal-encuadre');
  const btnCloseModalOE = document.getElementById('btn-close-modal-oe');

  function showToast(msg: string) {
    const toast = document.getElementById('save-status-toast');
    if (toast) {
      toast.innerText = msg;
      toast.classList.add('show');
      setTimeout(() => toast.classList.remove('show'), 2800);
    }
  }

  function renderView() {
    if (!encuadreData) return;

    if (titleEl) titleEl.innerText = encuadreData.titulo_tesis || 'Regeneración urbana cultural en barrios marginados';
    if (subtitleEl) subtitleEl.innerText = encuadreData.subtitulo || 'Casos de estudio: El Raval, Gamcheon y Barrio Yungay';
    if (problemEl) problemEl.innerText = encuadreData.problema_central || 'Pendiente de formulación.';
    if (hypothesisEl) hypothesisEl.innerText = encuadreData.hipotesis_central || 'Pendiente de formulación.';
    if (generalObjEl) generalObjEl.innerText = encuadreData.objetivo_general || 'Pendiente de formulación.';

    if (oeContainer) {
      oeContainer.innerHTML = '';
      if (objetivosData.length === 0) {
        oeContainer.innerHTML = '<p style="color:var(--text-muted); font-style:italic;">No hay objetivos específicos registrados aún.</p>';
        return;
      }

      objetivosData.forEach(oe => {
        const card = document.createElement('div');
        card.className = 'oe-card-item';
        card.style.cssText = `
          padding: 18px;
          border: 1.5px solid var(--border);
          border-radius: 8px;
          background: #ffffff;
          box-shadow: var(--shadow-sm);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;
        `;

        const tagColor = oe.color_tag === 'leaf-hat' ? '#2e7d32' : (oe.color_tag === 'woven-basket' ? '#b27e49' : 'var(--strawbs)');
        const tagBg = oe.color_tag === 'leaf-hat' ? '#e8f5e9' : (oe.color_tag === 'woven-basket' ? '#fff8e6' : 'var(--primary-subtle)');

        card.innerHTML = `
          <div>
            <div style="display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:10px;">
              <span style="background:${tagBg}; color:${tagColor}; font-weight:800; font-size:0.75rem; padding:3px 8px; border-radius:4px; font-family:var(--font-mono);">${escapeHtml(oe.codigo)}</span>
              <div style="display:flex; gap:6px;">
                <button class="btn-secondary btn-edit-oe" data-oe-id="${oe.id}" style="padding:3px 7px; font-size:0.72rem;" title="Editar objetivo">Editar</button>
                <button class="btn-del btn-del-oe" data-oe-id="${oe.id}" style="padding:3px 6px;" title="Eliminar objetivo">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                </button>
              </div>
            </div>
            <h3 style="color:${tagColor}; font-size:0.95rem; font-weight:700; margin-bottom:8px; line-height:1.35;">${escapeHtml(oe.titulo)}</h3>
            <p style="font-size:0.84rem; line-height:1.55; color:var(--text-main); margin-bottom:12px;"><strong>Objetivo:</strong> ${escapeHtml(oe.descripcion)}</p>
          </div>
          <div style="padding-top:10px; border-top:1px dashed var(--border); font-size:0.78rem; color:var(--text-muted);">
            <strong style="color:var(--text-main);">Instrumento:</strong> ${escapeHtml(oe.instrumento)}
          </div>
        `;

        oeContainer.appendChild(card);
      });

      // Eventos para editar y eliminar OEs
      oeContainer.querySelectorAll('.btn-edit-oe').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = btn.getAttribute('data-oe-id');
          const oe = objetivosData.find(o => o.id.toString() === id);
          if (!oe) return;
          openModalOE(oe);
        });
      });

      oeContainer.querySelectorAll('.btn-del-oe').forEach(btn => {
        btn.addEventListener('click', async () => {
          const id = btn.getAttribute('data-oe-id');
          if (!id) return;
          if (confirm('¿Está segura de que desea eliminar este objetivo específico de SQLite?')) {
            try {
              await Api.deleteObjetivoEspecifico(id);
              objetivosData = objetivosData.filter(o => o.id.toString() !== id);
              renderView();
              showToast('Objetivo específico eliminado');
            } catch (err: any) {
              alert('Error al eliminar: ' + (err?.message || err));
            }
          }
        });
      });
    }
  }

  async function loadData() {
    try {
      const res = await Api.getEncuadre();
      encuadreData = res.encuadre;
      objetivosData = res.objetivos || [];
      renderView();
    } catch (err) {
      console.error('Error cargando encuadre doctoral:', err);
    }
  }

  function openModalEncuadre() {
    if (!modalEncuadre || !encuadreData) return;
    (document.getElementById('input-enc-title') as HTMLInputElement).value = encuadreData.titulo_tesis || '';
    (document.getElementById('input-enc-subtitle') as HTMLInputElement).value = encuadreData.subtitulo || '';
    (document.getElementById('input-enc-problem') as HTMLTextAreaElement).value = encuadreData.problema_central || '';
    (document.getElementById('input-enc-hypothesis') as HTMLTextAreaElement).value = encuadreData.hipotesis_central || '';
    (document.getElementById('input-enc-general-obj') as HTMLTextAreaElement).value = encuadreData.objetivo_general || '';
    modalEncuadre.style.display = 'flex';
  }

  function openModalOE(oeToEdit?: AtlasObjetivoEspecifico) {
    if (!modalOE) return;
    const formTitle = document.getElementById('modal-oe-title');
    const idInput = document.getElementById('input-oe-id') as HTMLInputElement;
    const codInput = document.getElementById('input-oe-code') as HTMLInputElement;
    const titInput = document.getElementById('input-oe-title') as HTMLInputElement;
    const descInput = document.getElementById('input-oe-desc') as HTMLTextAreaElement;
    const instInput = document.getElementById('input-oe-inst') as HTMLInputElement;
    const colInput = document.getElementById('input-oe-color') as HTMLSelectElement;

    if (oeToEdit) {
      if (formTitle) formTitle.innerText = `Editar Objetivo ${oeToEdit.codigo}`;
      idInput.value = oeToEdit.id.toString();
      codInput.value = oeToEdit.codigo;
      titInput.value = oeToEdit.titulo;
      descInput.value = oeToEdit.descripcion;
      instInput.value = oeToEdit.instrumento;
      colInput.value = oeToEdit.color_tag || 'strawbs';
    } else {
      if (formTitle) formTitle.innerText = 'Crear Nuevo Objetivo Específico';
      idInput.value = '';
      codInput.value = `OE${objetivosData.length + 1}`;
      titInput.value = '';
      descInput.value = '';
      instInput.value = '';
      colInput.value = 'strawbs';
    }

    modalOE.style.display = 'flex';
  }

  // Eventos de apertura de modales
  btnEditEncuadre?.addEventListener('click', openModalEncuadre);
  btnAddOE?.addEventListener('click', () => openModalOE());

  btnCloseModalEncuadre?.addEventListener('click', () => {
    if (modalEncuadre) modalEncuadre.style.display = 'none';
  });

  btnCloseModalOE?.addEventListener('click', () => {
    if (modalOE) modalOE.style.display = 'none';
  });

  // Envío formulario Encuadre Central
  formEncuadre?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const titulo_tesis = (document.getElementById('input-enc-title') as HTMLInputElement).value.trim();
    const subtitulo = (document.getElementById('input-enc-subtitle') as HTMLInputElement).value.trim();
    const problema_central = (document.getElementById('input-enc-problem') as HTMLTextAreaElement).value.trim();
    const hipotesis_central = (document.getElementById('input-enc-hypothesis') as HTMLTextAreaElement).value.trim();
    const objetivo_general = (document.getElementById('input-enc-general-obj') as HTMLTextAreaElement).value.trim();

    try {
      const res = await Api.updateEncuadre({
        titulo_tesis,
        subtitulo,
        problema_central,
        hipotesis_central,
        objetivo_general
      });
      encuadreData = res.encuadre;
      renderView();
      if (modalEncuadre) modalEncuadre.style.display = 'none';
      showToast('Encuadre doctoral actualizado en SQLite');
    } catch (err: any) {
      alert('Error al guardar encuadre: ' + (err?.message || err));
    }
  });

  // Envío formulario Objetivo Específico
  formOE?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const id = (document.getElementById('input-oe-id') as HTMLInputElement).value;
    const codigo = (document.getElementById('input-oe-code') as HTMLInputElement).value.trim();
    const titulo = (document.getElementById('input-oe-title') as HTMLInputElement).value.trim();
    const descripcion = (document.getElementById('input-oe-desc') as HTMLTextAreaElement).value.trim();
    const instrumento = (document.getElementById('input-oe-inst') as HTMLInputElement).value.trim();
    const color_tag = (document.getElementById('input-oe-color') as HTMLSelectElement).value;

    try {
      if (id) {
        await Api.updateObjetivoEspecifico(id, { codigo, titulo, descripcion, instrumento, color_tag });
        const idx = objetivosData.findIndex(o => o.id.toString() === id);
        if (idx !== -1) {
          objetivosData[idx] = { ...objetivosData[idx], codigo, titulo, descripcion, instrumento, color_tag };
        }
        showToast('Objetivo específico actualizado en SQLite');
      } else {
        const res = await Api.addObjetivoEspecifico({
          codigo,
          titulo,
          descripcion,
          instrumento,
          color_tag,
          orden: objetivosData.length + 1
        });
        objetivosData.push({
          id: res.id,
          codigo,
          titulo,
          descripcion,
          instrumento,
          color_tag,
          orden: objetivosData.length + 1,
          actualizado_en: new Date().toISOString()
        });
        showToast('Objetivo específico creado en SQLite');
      }

      renderView();
      if (modalOE) modalOE.style.display = 'none';
    } catch (err: any) {
      alert('Error al guardar objetivo: ' + (err?.message || err));
    }
  });

  function escapeHtml(str: string): string {
    const div = document.createElement('div');
    div.innerText = str;
    return div.innerHTML;
  }

  loadData();
}
